import React, { useEffect, useState } from 'react';
import { Button } from './ui/button';
import { Menu, X } from 'lucide-react';

const LOGO_URL = '/logo.png';

const Navbar = ({ translations, language }) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const t = translations[language];

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 20);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'start' });
      setIsMobileMenuOpen(false);
    }
  };

  const navItems = [
    { key: 'services', section: 'services' },
    { key: 'process', section: 'process' },
    { key: 'projects', section: 'projects' },
    { key: 'faq', section: 'faq' },
    { key: 'contact', section: 'contact' },
  ];

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        isScrolled
          ? 'bg-white/95 backdrop-blur-lg shadow-md border-b border-slate-100'
          : 'bg-white/90 backdrop-blur-md border-b border-slate-100/80'
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-20">
          <button
            type="button"
            className="flex items-center gap-3"
            onClick={() => scrollToSection('hero')}
            aria-label="Ir al inicio"
          >
            <img
              src={LOGO_URL}
              alt="Solvere - Sistemas que resuelven"
              loading="eager"
              decoding="async"
              className="h-14 md:h-16 w-auto shrink-0"
            />

            <div className="hidden sm:block text-left leading-tight">
              <p className="text-slate-900 font-bold text-lg">Solvere</p>
              <p className="text-xs text-slate-500 mt-1">Sistemas que resuelven</p>
            </div>
          </button>

          <div className="hidden lg:flex items-center space-x-6">
            {navItems.map((item) => (
              <button
                key={item.key}
                onClick={() => scrollToSection(item.section)}
                className="text-slate-700 hover:text-blue-700 transition-colors font-medium"
              >
                {t.nav[item.key]}
              </button>
            ))}

            <Button
              onClick={() => scrollToSection('contact')}
              className="bg-blue-600 hover:bg-blue-700 text-white"
            >
              {t.nav.cta}
            </Button>
          </div>

          <div className="lg:hidden flex items-center gap-2">
            <button
              onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)}
              className="text-slate-700 hover:text-blue-700 transition-colors"
              aria-label="Abrir menú"
            >
              {isMobileMenuOpen ? (
                <X className="h-6 w-6" />
              ) : (
                <Menu className="h-6 w-6" />
              )}
            </button>
          </div>
        </div>

        {isMobileMenuOpen && (
          <div className="lg:hidden pb-4 bg-white/95 backdrop-blur-lg rounded-b-2xl shadow-lg border border-slate-100 border-t-0">
            <div className="flex flex-col space-y-2 px-4 pt-2">
              {navItems.map((item) => (
                <button
                  key={item.key}
                  onClick={() => scrollToSection(item.section)}
                  className="text-slate-700 hover:text-blue-700 transition-colors font-medium text-left py-2"
                >
                  {t.nav[item.key]}
                </button>
              ))}

              <Button
                onClick={() => scrollToSection('contact')}
                className="bg-blue-600 hover:bg-blue-700 text-white w-full mt-2"
              >
                {t.nav.cta}
              </Button>
            </div>
          </div>
        )}
      </div>
    </nav>
  );
};

export default Navbar;